import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { StuplayConfig } from '../stuplay-config';
import { getParams } from '../helpers';
import { environment } from 'src/environments/environment';

export interface ContentSubscriptionReport {
    progress: number; // 0-100
    score: number;    // 0-100
    duration: number;
}

@Injectable()
export class StatisticsProvider {

    constructor(private http: HttpClient, private stuplayConfig: StuplayConfig) { }

    launchActivity(id: number): Observable<any> {
        return this.http
            .post(`${this.stuplayConfig.envVar.API_URL}/learning/section-contents/${id}/launch`, {})
            .pipe(map((data) => data));
    }

    launchContent(id: number, params: any): Observable<any> {
        return this.http
            .post(`${this.stuplayConfig.envVar.API_URL}/learning/contents/${id}/launch`, params)
            .pipe(map((data) => data));
    }

    /**
     * Obtiene el progreso/score GENERAL (autoritativo) de un curso desde el servicio de reporting.
     *
     * Es la misma fuente que usa la plataforma para mostrar el avance total: el cálculo local
     * (doneAt / totalUnits) puede diferir del valor oficial, así que para el "progreso general"
     * que se muestra en el sidebar y en course-presentation usamos este endpoint como verdad.
     *
     * GET {REPORTING_URL}/companies/{companyId}/contents/{courseId}/subscriptions?context=course&account_ids={accountId}
     * Respuesta: { "<accountId>": { date, type, context: { progress, score, duration, ... } } }
     */
    getContentSubscriptionReport(companyId: number, courseId: number, accountId: number): Observable<ContentSubscriptionReport | null> {
        const params = getParams({ context: 'course', account_ids: accountId });
        return this.http
            .get(`${environment.envVar.REPORTING_URL}/companies/${companyId}/contents/${courseId}/subscriptions`, { params })
            .pipe(
                map((res: any) => {
                    const entry = res?.[accountId] ?? res?.[String(accountId)];
                    const ctx = entry?.context ?? entry;
                    if (!ctx) { return null; }
                    return {
                        progress: ctx.progress ?? 0,
                        score: ctx.score ?? 0,
                        duration: ctx.duration ?? 0,
                    };
                }),
                catchError(() => of(null)),
            );
    }
}
